import { render, staticRenderFns } from "./AssistentForm.vue?vue&type=template&id=39934bd2&scoped=true&"
import script from "./AssistentForm.vue?vue&type=script&lang=js&"
export * from "./AssistentForm.vue?vue&type=script&lang=js&"
import style0 from "./AssistentForm.vue?vue&type=style&index=0&id=39934bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39934bd2",
  null
  
)

export default component.exports